// Mappers for search-related entities
// Identity mappers for 1:1 mapping

import type {
  GlobalSearchResponseDto,
  ProductionOrderSearchResponseDto,
  PartSearchResponseDto,
  ProductionOperationSearchResponseDto,
  ProductionBatchSearchResponseDto,
  NcFileSearchResponseDto,
  ToolSearchResponseDto,
  DocumentSearchResponseDto,
  RecipeSearchResponseDto,
  RecipeOperationSearchResponseDto,
  MachineEventSearchResponseDto,
  MachineEventCycleSearchResponseDto,
} from '../../generated/models';

import type { SuggestionResponse as SuggestionResponseLocal } from '@api/modules/search/types';

import type {
  GlobalSearchResponse,
  ProductionOrderSearchResponse,
  PartSearchResponse,
  ProductionOperationSearchResponse,
  ProductionBatchSearchResponse,
  NcFileSearchResponse,
  ToolSearchResponse,
  DocumentSearchResponse,
  RecipeSearchResponse,
  RecipeOperationSearchResponse,
  MachineEventSearchResponse,
  MachineEventCycleSearchResponse,
  SuggestionResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toGlobalSearchResponse = (dto: GlobalSearchResponseDto): GlobalSearchResponse => dto;
export const toProductionOrderSearchResponse = (dto: ProductionOrderSearchResponseDto): ProductionOrderSearchResponse =>
  dto;
export const toPartSearchResponse = (dto: PartSearchResponseDto): PartSearchResponse => dto;
export const toProductionOperationSearchResponse = (
  dto: ProductionOperationSearchResponseDto
): ProductionOperationSearchResponse => dto;
export const toProductionBatchSearchResponse = (dto: ProductionBatchSearchResponseDto): ProductionBatchSearchResponse =>
  dto;
export const toNcFileSearchResponse = (dto: NcFileSearchResponseDto): NcFileSearchResponse => dto;
export const toToolSearchResponse = (dto: ToolSearchResponseDto): ToolSearchResponse => dto;
export const toDocumentSearchResponse = (dto: DocumentSearchResponseDto): DocumentSearchResponse => dto;
export const toRecipeSearchResponse = (dto: RecipeSearchResponseDto): RecipeSearchResponse => dto;
export const toRecipeOperationSearchResponse = (dto: RecipeOperationSearchResponseDto): RecipeOperationSearchResponse =>
  dto;
export const toMachineEventSearchResponse = (dto: MachineEventSearchResponseDto): MachineEventSearchResponse => dto;
export const toMachineEventCycleSearchResponse = (
  dto: MachineEventCycleSearchResponseDto
): MachineEventCycleSearchResponse => dto;

// Local type mappers (identity for 1:1)
export const toSuggestionResponse = (dto: SuggestionResponseLocal): SuggestionResponse => dto;
